import React from 'react';
import PropTypes from 'prop-types';

import PastDue from '../../shared-components/PastDue/PastDue';
import ClosedEditPage from './ClosedEditPage/ClosedEditPage';

const ClosedEdit = ({ isAccountPastDue }) => (
  <>
    <ClosedEditPage />
    <PastDue isAccountPastDue={isAccountPastDue} />
  </>
);

ClosedEdit.propTypes = {
  isAccountPastDue: PropTypes.bool.isRequired,
};

export default ClosedEdit;
